import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'stringToHtml', standalone: true })
export class NewlineToBrPipe implements PipeTransform {
  transform(value: string | undefined): string {
    return value?.replace(/(?:\r\n|\r|\n)/g, '<br>') ?? '';
  }
}
